import { PropsWithChildren, useEffect, useState } from 'react'
import { getTenantDomainUrl } from 'hooks/useGetTenantDomainUrl'
import { getTenantByDomain } from 'api/tenants'

export const TenantProvider = ({ children }: PropsWithChildren) => {
  const [isReady, setIsReady] = useState<boolean>(false)

  useEffect(() => {
    const domainUrl = getTenantDomainUrl()
    getTenantByDomain(domainUrl).then(() => {
      setIsReady(true)
    })
  }, [])

  return isReady ? <>{children}</> : null
}
